// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  setAlertRiskLevelsActionsSelectRedux,
  setAlertRiskLevelsRedux,
  setCriticalWordsRedux,
  setSlaRedux,
} from './slaSlice';
import {
  getSlaService,
  createSlaService,
  updateSlaService,
  createAutoAlertService,
  updateAutoAlertService,
  deleteAutoAlertService,
  createAlertKeywordService,
  deleteAlertKeywordService,
} from '../../services';

export const getSlaStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getSlaService();

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setSlaRedux(result.data));
      await dispatch(setAlertRiskLevelsRedux(result.data.alertriskLevels));
      await dispatch(
        setAlertRiskLevelsActionsSelectRedux(result.data.alertRiskLevelsActionsSelect)
      );
      await dispatch(setCriticalWordsRedux(result.data.keywords));
    }

    return result;
  };
};

export const storeCreateSla = (slaData: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await createSlaService(slaData);

    if (result.ok) {
      await dispatch(setSlaRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeUpdateSla = (slaData: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await updateSlaService(slaData);

    if (result.ok) {
      await dispatch(setSlaRedux(result.data));
      await dispatch(setAlertRiskLevelsRedux(result.data.alertriskLevels));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeCreateAutoAlert = (alertData: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await createAutoAlertService(alertData);

    if (result.ok) {
      await dispatch(setAlertRiskLevelsRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeUpdateAutoAlert = (id: string, alertData: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await updateAutoAlertService(id, alertData);

    if (result.ok) {
      await dispatch(setAlertRiskLevelsRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeDeleteAutoAlert = (id: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await deleteAutoAlertService(id);

    // Si el backend retorna toda la lista o algo que debamos setear, lo hacemos aquí:
    // if (result.ok && result.data) {
    //   await dispatch(setAlertRiskLevelsRedux(result.data));
    // }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeCreateKeyword = (keywordData: any): any => {
  return async (dispatch: any, getState: any) => {
    await dispatch(checkingPreload());

    const result = await createAlertKeywordService(keywordData);

    if (result.ok) {
      const { critical_words } = getState().sla;
      await dispatch(setCriticalWordsRedux([...critical_words, result.data]));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeDeleteKeyword = (id: string): any => {
  return async (dispatch: any, getState: any) => {
    await dispatch(checkingPreload());

    const result = await deleteAlertKeywordService(id);

    if (result.ok) {
      const { critical_words } = getState().sla;
      await dispatch(setCriticalWordsRedux(critical_words.filter((kw: any) => kw.id !== id)));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};
